<template>


    <div>
        <v-layout row justify-center>
        </v-layout>
        <v-layout row wrap>
            <v-toolbar size="120px" dark color="info">
                <v-toolbar-title class="baslikfont">{{$t("current_index_header")}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-flex xs4 sm4 md4>
                    <v-text-field flat="" solo-inverted="" hide-details v-model="search" :label="$t('Search')"
                        append-icon="search">
                    </v-text-field>
                </v-flex>
                <v-btn large="" @click="tumListe()" flat>{{$t('List')}}
                </v-btn>
                <v-tooltip bottom>
                    <v-icon slot="activator" dark @click="filtrele()">filter_list</v-icon>
                    <span>{{$t('Add-Search-Filter')}}</span>
                </v-tooltip>
                <v-menu bottom="" left>

                    <v-btn slot="activator" dark icon>
                        <v-icon>more_vert</v-icon>
                    </v-btn>
                    <v-list>

                        <v-list-tile @click="getListHtml()">
                            <v-list-tile-title>Html {{ $t('Download') }}</v-list-tile-title>
                        </v-list-tile>


                        <v-list-tile @click="getListExcel()">
                            <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>
                        </v-list-tile>

                    </v-list>
                </v-menu>
            </v-toolbar>
        </v-layout>
        <v-card flat>

            <v-data-table :headers="headers" :loading="progress" :rows-per-page-items=[50,100] :items="items"
                :search="search" id="datatable">
                <v-progress-linear slot="progress" indeterminate></v-progress-linear>
                <template slot="items" slot-scope="props">
                    <tr @click="git(props.item.Kod)" item>
                        <td class="text-xs-left">{{ props.item.Kod }}</td>
                        <td class="text-xs-left">{{ props.item.Unvan }}</td>
                        <td class="text-xs-left">{{ props.item.Tel1 }}</td>
                        <td class="text-xs-left">{{ props.item.Adres }}</td>
                    </tr>
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                     {{ $t('No-records-searched-for', { value: search}) }}
                </v-alert>
            </v-data-table>
        </v-card>

        <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="400px">
            <v-card color="grey lighten-5">

                <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
                <v-divider></v-divider>
                <v-card-text>

                    <v-layout row="" wrap="">
                        <div class="flex md12">
                            <cariaracomp v-bind:etiket="$t('Select-Starting-Current')" :loading="loadingcaribas" v-bind:value="Current.Filter.StartCode" v-model="Current.Filter.StartCode"></cariaracomp>

                             <cariaracomp v-bind:etiket="$t('Select-Ending-Current')" :loading="loadingcaribit" v-bind:value="Current.Filter.FinishCode" v-model="Current.Filter.FinishCode"></cariaracomp>

                             <cariaracomp v-bind:etiket="$t('Main-Account')" :loading="loadingcariana" v-bind:value="Current.Filter.MainAccount" v-model="Current.Filter.MainAccount"></cariaracomp>


                            <v-autocomplete hide-details clearable :items="hesapgurubu" v-model="Current.Filter.Group"
                                :label="$t('Account-Group')" multiple item-text="Title" item-value="Kod">
                                <template slot="selection" slot-scope="{ item, index }">
                                    <v-chip v-if="index === 0">
                                        <h4> <span>{{ item.Kod }}</span> </h4>
                                    </v-chip>
                                    <span v-if="index === 1" class="grey--text caption">(+{{
                                 Current.Filter.Group.length - 1 }} {{ $t('other-record') }})</span>
                                </template>
                            </v-autocomplete>
                            <v-autocomplete hide-details clearable v-model="Current.Filter.AnalyseCode" :items="analiz"
                                :label="$t('Analysis-Code')" item-text="AnalizAdi" item-value="AnalizKod" max-height="400">
                            </v-autocomplete>

                            <v-autocomplete hide-details :items="masrafmerkezi" clearable
                                v-model="Current.Filter.SalesCenter" :label="$t('Expense-Center-v2')" item-text="Title"
                                item-value="Code">
                            </v-autocomplete>

                            <v-select hide-details v-model="Current.Filter.AccountType" :items="musteritipi"
                                label="Cari Tip" item-text="text" item-value="value">
                            </v-select>

                            <div class="flex md12">
                                <v-checkbox :label="$t('Account-Group-Empty-Ones')" v-model="Current.Filter.GroupEmpty"
                                    hide-details=""></v-checkbox>
                                <v-checkbox :label="$t('Accounting-Code-Empty-Ones')" v-model="Current.Filter.AccountingEmpty"
                                    hide-details=""></v-checkbox>
                                <v-checkbox :label="$t('External-Transfer-Code-Empty-Ones')"
                                    v-model="Current.Filter.StreamCodeEmpty" hide-details=""></v-checkbox>
                                <v-checkbox :label="$t('Ones-with-Expense-Centre-Explanation')"
                                    v-model="Current.Filter.SalesCenterNotEmpty" hide-details=""></v-checkbox>
                                <v-checkbox :label="$t('All-Companies')" v-model="tumsirketler" hide-details=""></v-checkbox>

                            </div>

                        </div>
                    </v-layout>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click="filtreiptal()">{{$t("cancel_button")}}</v-btn>
                    <v-btn color="blue darken-1" flat @click="tumListe()">{{ $t('Apply-Filters') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <template>
            <v-card>
                <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
                    :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'"
                    v-model="snackbar">
                    {{ text }}
                    <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
                </v-snackbar>
            </v-card>
        </template>
    </div>
</template>


<script>
    import auth from '../../../api/auth'
    import cariaracomp from '@/components/app/customcomp/cariaracomp'

    export default {
        data() {
            return {

                tumsirketler: null,
                loadingcaribas: false,
                statecaribas: [],
                searchcaribas: null,
                loadingcaribit: false,
                statecaribit: [],
                searchcaribit: null,
                loadingcariana: false,
                statecariana: [],
                searchcariana: null,

                denemestatus: false,
                searchcari: null,
                analiz: [],
                masrafmerkezi: [],
                hesapgurubu: [],
                statecari: [],
                musteritipi: [{
                    text: this.$t('All'),
                    value: '0'
                }, {
                    text: this.$t('Individual'),
                    value: '1'
                }, {
                    text: this.$t('Corporate'),
                    value: '2'
                }],
                dialogfiltre: false,
                tooltip: false,
                el: null,
                loading: false,
                items: [],
                search: null,
                kayitvarmi: false,
                Currents: [],
                progress1: true,


                headers: [{
                        text: this.$t('Currentcode_label'),
                        value: 'Kod'
                    },
                    {
                        text: this.$t('Title_label'),
                        value: 'Unvan'
                    },
                    {
                        text: this.$t('Phonenumber_label') + '1',
                        value: 'Tel1'
                    },
                    {
                        text: this.$t('Address_label'),
                        value: 'Adres'
                    }
                ],


                Current: {
                    CompanyCode: null,
                    Code: null,
                    SummaryInfoShow: false,
                    Filter: {
                        StartCode: null,
                        FinishCode: null,
                        MainAccount: 0,
                        Group: [],
                        AnalyseCode: null,
                        SalesCenter: null,
                        AccountType: '0', //0 : hepsi ,1 : bireysel, 2 : Kurumsal
                        GroupEmpty: false,
                        AccountingEmpty: false,
                        StreamCodeEmpty: false,
                        SalesCenterNotEmpty: false,
                    }
                },
                selected: '',
                m: false,
                k: false,
                dialog: false,
                dialog_baslik: '',
                codegorunum: true,
                snackbar: false,
                y: 'top',
                x: 'right',
                mode: '',
                timeout: 6000,
                text: '',
                progress: false
            }
        },
        components:{
            cariaracomp
        },
        methods: {
            filtreiptal() {
                this.Current.Filter.StartCode = null
                this.Current.Filter.FinishCode = null
                this.Current.Filter.MainAccount = 0
                this.Current.Filter.Group = []
                this.Current.Filter.AnalyseCode = null
                this.Current.Filter.SalesCenter = null
                this.Current.Filter.AccountType = '0'
                this.Current.Filter.GroupEmpty = false
                this.Current.Filter.AccountingEmpty = false
                this.Current.Filter.StreamCodeEmpty = false
                this.Current.Filter.SalesCenterNotEmpty = false
                this.tumsirketler=false
                this.dialogfiltre=false
            },

            filtrele() {
                this.dialogfiltre = true;
                var credentials = JSON.parse(window.localStorage.getItem('credentials'));

                var params = {
                    CompanyCode: credentials.SirketKodu
                }

                this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {
                    this.hesapgurubu = response.body
                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                    } else {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                    }
                })

                this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {
                    this.masrafmerkezi = response.body
                }, (response) => {
                    if (response.status === 0) {

                    } else {

                    }
                })

                this.$http.post(auth.API_URL + 'api/Analysis/List', params, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {
                    this.progress = false
                    this.analiz = response.body
                }, (response) => {
                    if (response.status === 0) {
                        this.progress = false
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                    } else {
                        this.progress = false
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                    }
                })


            },
            git: git,
            getListHtml: getListHtml,
            getListExcel: getListExcel,
            tumListe: tumListe,
 

        },

        beforeMount: beforeMount,
        watch: {
           
        }
    }

    function git(v) {
        var url = "#/cari/goster/" + v
        window.open(url, '_target')
    }

    function getListHtml() {

        this.progress = true

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        var lang = localStorage.getItem('lang')

        if (this.tumsirketler == true) {
            this.Current.CompanyCode = 0
        } else {
            this.Current.CompanyCode = credentials.SirketKodu
        }

        var params = this.Current

        this.$http.post(auth.API_URL + "api/Current/ListHtml", params, {
            headers: {
                Authorization: "Bearer " + auth.getAuthHeader()
            }
        }).then((response) => {


          if (lang=='en')
          {
            
             var bodyhtml=response.bodyText;
             bodyhtml=bodyhtml.toString().replace('Cari Kodu','Account Code');
             bodyhtml=bodyhtml.toString().replace('<title> CARİ HESAP LİSTESİ </title>','<title> Currents List </title>');
             bodyhtml=bodyhtml.toString().replace("<font face = 'Arial' size = '4' color = '#FFFFF0'>CARİ HESAP LİSTESİ</font>","<font face = 'Arial' size = '4' color = '#FFFFF0'>Currents List</font>")
             bodyhtml=bodyhtml.toString().replace('Cari Adı','Account Title');
             bodyhtml=bodyhtml.toString().replace('Tel','Phone');
             bodyhtml=bodyhtml.toString().replace('Adres','Adresses');
             bodyhtml=bodyhtml.toString().replace('adet kayıt listelendi.','records listed');
             
             response.bodyText=bodyhtml;
             
          }

            this.progress = false
            this.load1 = true
            var blob = new Blob([response.bodyText], {
                type: 'application/html'
            });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = this.$t('CurrentList') + ".html";
            link.click();
        }, (response) => {
            if (response.status === 0) {
                this.progress = false

            } else {
                this.progress = false

            }
        })
    }


    function getListExcel() {

        this.progress = true

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));


        if (this.tumsirketler == true) {
            this.Current.CompanyCode = 0
        } else {
            this.Current.CompanyCode = credentials.SirketKodu
        }

        var params = this.Current

        this.$http.post(auth.API_URL + "api/Current/ListExcel", params, {
            headers: {
                Authorization: "Bearer " + auth.getAuthHeader()
            },
            responseType: "arraybuffer"
        }).then((response) => {
            let message = String.fromCharCode.apply( null, new Uint16Array(response.body) );
            console.log(message);
   
    

            this.progress = false
            this.load1 = true
            console.log(response.data);
            var blob = new Blob([response.data], {
                type: 'application/xlsx'
            });
            console.log(blob);
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download =this.$t('CurrentList') + ".xlsx"; 
            link.click();
        }, (response) => {
            if (response.status === 0) {
                this.progress = false

            } else {
                this.progress = false

            }
        })
    }

    function tumListe() {
        this.progress = true

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        if (this.tumsirketler == true) {
            this.Current.CompanyCode = 0
        } else {
            this.Current.CompanyCode = credentials.SirketKodu
        }

        var params = this.Current

        this.$http.post(auth.API_URL + 'api/Current/List', params, {
            headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
        }).then((response) => {

            this.items = response.body
            this.progress = false

        }, (response) => {
            if (response.status === 0) {
                this.progress = false

            } else {
                this.progress = false

            }
        })
        this.dialogfiltre = false
    }

    function beforeMount() {

    }
</script>

<style>
</style>